<a
  title="Rentag"
  class="flex items-end justify-between"
  href="https://rentag.ru"
  target="_blank"
  referrerpolicy="no-referrer"
  [ngClass]="{ 'lg:py-4': !removePaddings }"
>
  <div class="mr-3 w-[169px] h-[44px]">
    <img class="w-full h-full" src="/assets/img/branding/logo-full.svg" alt="Rentag" />
  </div>
</a>
